import Cookie from './CookieService';

// Elimina las cookies asociadas a la sesión del usuario
export const clearSession = () => {
    Cookie.remove(process.env.REACT_APP_COOKIE_NAME, { path: '/' });
    Cookie.remove(process.env.REACT_APP_REFRESH_COOKIE_NAME, { path: '/' });
};

// Finaliza la sesión y redirige al login
export const closeSession = () => {
    clearSession();
    window.location.href = '/iniciar-sesion';
};